export default __webpack_public_path__ + "static/media/rubbish-opened.d7e340e7.svg";